import React from 'react';
import { faqs } from '../data/mockData';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const FAQSection = ({ onOpenContactForm }) => {
  const header = useScrollAnimation({ threshold: 0.15 });
  const content = useScrollAnimation({ threshold: 0.1 });
  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-[#093336]/20 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div ref={header.ref} className={`text-center max-w-2xl mx-auto mb-16 scroll-fade-up ${header.isVisible ? 'scroll-visible' : ''}`}>
          <span className="inline-block bg-[#A5BF23]/10 text-[#A5BF23] px-4 py-1.5 rounded-full text-xs font-bold tracking-[0.2em] mb-4">FAQ</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#F0F4F4] mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>Brand Name Registration FAQ</h2>
          <p className="text-base text-[#A0B2B2] leading-relaxed">Everything you need to know about registering your brand name as a trademark.</p>
        </div>
        <div ref={content.ref} className={`max-w-3xl mx-auto scroll-fade-up scroll-delay-2 ${content.isVisible ? 'scroll-visible' : ''}`}>
          <Accordion type="single" collapsible>
            {faqs.map((faq) => (
              <AccordionItem key={faq.id} value={`item-${faq.id}`} data-testid={`faq-item-${faq.id}`} className="border-b border-white/10">
                <AccordionTrigger className="text-left text-sm font-semibold text-[#F0F4F4] hover:text-[#A5BF23] py-5 [&[data-state=open]]:text-[#A5BF23]">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-[#A0B2B2] leading-relaxed pb-5">{faq.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          <div className="text-center mt-12 pt-8 border-t border-white/10">
            <p className="text-sm text-[#A0B2B2] mb-4">Still have questions?</p>
            <Button data-testid="faq-cta" onClick={onOpenContactForm}
              className="bg-[#A5BF23] hover:bg-[#8A9F1D] text-[#041B1C] font-semibold px-8 h-11 rounded-full transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_8px_32px_rgba(165,191,35,0.3)]">
              Talk to an Expert <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
